import type { TFunction } from "i18next";
import type { CatalogVerbView } from "./types";

export const commandPresentationKeys = {
  "service.status": { title: "service_statusTitle", description: "service_statusDescription" },
  "service.start": { title: "service_startTitle", description: "service_startDescription" },
  "service.stop": { title: "service_stopTitle", description: "service_stopDescription" },
  "service.restart": { title: "service_restartTitle", description: "service_restartDescription" },
  "service.status.all": { title: "service_status_allTitle", description: "service_status_allDescription" },
  "disk.usage": { title: "disk_usageTitle", description: "disk_usageDescription" },
  "vpn.status": { title: "vpn_statusTitle", description: "vpn_statusDescription" },
  "download.status": { title: "download_statusTitle", description: "download_statusDescription" },
  "system.telemetry": { title: "system_telemetryTitle", description: "system_telemetryDescription" },
  "system.app.status": { title: "system_app_statusTitle", description: "system_app_statusDescription" },
  "system.db.health": { title: "system_db_healthTitle", description: "system_db_healthDescription" },
  "user.status": { title: "user_statusTitle", description: "user_statusDescription" },
  "fail2ban.status": { title: "fail2ban_statusTitle", description: "fail2ban_statusDescription" },
  "quota.status": { title: "quota_statusTitle", description: "quota_statusDescription" },
  "update.check": { title: "update_checkTitle", description: "update_checkDescription" },
  "user.ban": { title: "user_banTitle", description: "user_banDescription" },
  "user.unban": { title: "user_unbanTitle", description: "user_unbanDescription" },
  "user.create": { title: "user_createTitle", description: "user_createDescription" },
  "fail2ban.unban": { title: "fail2ban_unbanTitle", description: "fail2ban_unbanDescription" },
  "backup.trigger": { title: "backup_triggerTitle", description: "backup_triggerDescription" },
  "app.update": { title: "app_updateTitle", description: "app_updateDescription" },
  "quota.enable": { title: "quota_enableTitle", description: "quota_enableDescription" },
  "quota.disable": { title: "quota_disableTitle", description: "quota_disableDescription" },
  "quota.set": { title: "quota_setTitle", description: "quota_setDescription" },
  "geoblock.disable": { title: "geoblock_disableTitle", description: "geoblock_disableDescription" },
  "network.speedtest": { title: "network_speedtestTitle", description: "network_speedtestDescription" },
} as const;
export function commandPresentation(verb: Pick<CatalogVerbView, "verb" | "title" | "description">, t: TFunction<"commandChannel">) {
  const keys = Object.prototype.hasOwnProperty.call(commandPresentationKeys, verb.verb)
    ? commandPresentationKeys[verb.verb as keyof typeof commandPresentationKeys] : undefined;
  return keys ? { title: t($ => $[keys.title]), description: t($ => $[keys.description]) }
    : { title: verb.title, description: verb.description };
}
export function commandLabel(verb: string, t: TFunction<"commandChannel">): string {
  return commandPresentation({ verb, title: verb, description: "" }, t).title;
}
const availabilityKeys = ["no_installed_apps", "no_download_client", "vpn_not_configured", "fail2ban_not_installed"] as const;
export function commandAvailabilityText(verb: CatalogVerbView, t: TFunction<"commandChannel">): string {
  const key = availabilityKeys.find(value => value === verb.unavailableReasonCode);
  return key ? t($ => $[key]) : verb.unavailableReason ?? t($ => $.unavailableHint);
}
